export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}

export interface UserSettings {
	email: string;
	includeInSearch: boolean;
	includeInNetwork: boolean;
}

export interface ContactSettings {
	includeInSearch: boolean | undefined;
	includeInNetwork: boolean | undefined;
}
